import type { LazyImageProps } from '@sunwebgroup/uds-ui/lazy-image'
import { buildImgSrc, buildImgSrcSet } from '@/helpers/image-url'
import { LazyImage as UdsLazyImage } from '@sunwebgroup/uds-ui/lazy-image'

const DEFAULT_PLACEHOLDER_IMAGE_WIDTH = 20
interface MediaServerLazyImageProps extends Omit<LazyImageProps, 'placeholderSrc'> {
  widths: number[]
}

/**
 * This Image component wraps UDS LazyImage utility component to provide a standardized way to handle lazy loaded images
 *  The purpose of this wrapper is to do a separation of concerns between UI/UX and infrastructure details on how image URL
 *  for our media server are built.
 */
export function MediaServerLazyImage({ src, widths, ...props }: MediaServerLazyImageProps) {
  return (
    <UdsLazyImage
      src={buildImgSrc(src ?? '', Math.max(...widths))}
      srcSet={buildImgSrcSet(src ?? '', widths)}
      placeholderSrc={buildImgSrc(src ?? '', DEFAULT_PLACEHOLDER_IMAGE_WIDTH)}
      {...props}
    />
  )
}
